export const baseUrl=process.env.REACT_APP_BASE_URL
export const imageUrl=process.env.REACT_APP_IMAGE_URL